import { VARIANT_NAMES } from "../../THEME_BASE";
import { opacify } from "../../utils";
const alertColors = (colors, isLightTheme) => Object.fromEntries(
  VARIANT_NAMES.map((variantName) => [
    variantName,
    {
      background: isLightTheme ? opacify(colors[variantName][5], 0.1) : opacify(colors[variantName][3], 0.15),
      border: isLightTheme ? colors[variantName][2] : colors[variantName][8]
    }
  ])
);
export default alertColors;
